import { API_BASE_URL, FAILURE, POST, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";
import moment from "moment";

export async function obtenerListaUsuarios(obj, tag) {
    try {
        let data = [];
        const { code, body } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/usuario-web/list-usuario-plataforma",
            API_BASE_URL + "/usuario-web/list-usuario-plataforma",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data = body;
            for (let i = 0; i < data.length; i++) {
                data[i].fechamodificacion = moment(data[i].fechaModificacion).format("DD/MM/YYYY HH:mm");
                data[i].habilitadolabel = data[i].habilitado === 1 ? tag("label_yes") : tag("label_no");
            }
        }
        return data;
    } catch (err) {
        console.log("obtenerListaUsuarios err");
        console.log(err);
        return [];
    }
}

export async function disableUsuarioWeb(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/usuario-web/disable-usuario-plataforma",
            API_BASE_URL + "/usuario-web/disable-usuario-plataforma",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("disableUsuarioWeb err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function enableUsuarioWeb(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/usuario-web/enable-usuario-plataforma",
            API_BASE_URL + "/usuario-web/enable-usuario-plataforma",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("enableUsuarioWeb err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function updateUsuarioPlataforma(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/usuario-web/update-usuario-plataforma",
            API_BASE_URL + "/usuario-web/update-usuario-plataforma",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("updateUsuarioPlataforma err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function updatePasswordUsuarioPlataforma(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/usuario-web/update-password-usuario-plataforma",
            API_BASE_URL + "/usuario-web/update-password-usuario-plataforma",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("updatePasswordUsuarioPlataforma err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function obtenerUsuarioEmpresaPlataforma(obj, tag) {
    try {
        let data = { error: true, body: [] };
        const { code, message, body } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/usuario-web/obtener-usuario-empresa-plataforma",
            API_BASE_URL + "/usuario-web/obtener-usuario-empresa-plataforma",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
            data.body = body;
            for (let i = 0; i < data.body.length; i++) {
                data.body[i].fechamodificacion = moment(data.body[i].fechaModificacion).format("DD/MM/YYYY HH:mm");
                data.body[i].essubcuenta = data.body[i].habilitado === 1 ? tag("label_yes") : tag("label_no");
            }
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("obtenerUsuarioEmpresaPlataforma err");
        console.log(err);
        return { error: true, message: err, body: [] };
    }
}

export async function existeUsuario(obj) {
    try {
        let data = { error: true };
        const { code, message, body } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/usuario-web/existe-usuario",
            API_BASE_URL + "/usuario-web/existe-usuario",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
            data.total = body[0].total;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("updatePasswordUsuarioPlataforma err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function crearUsuarioPlataforma(obj, tag) {
    try {
        let data = { error: true, };
        const { code, message, } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/usuario-web/create-user",
            API_BASE_URL + "/usuario-web/create-user",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("crearUsuarioPlataforma err");
        console.log(err);
        return { error: true, message: err, };
    }
}

export async function recoverPasswordUsuarioPlataforma(obj) {
    try {
        let data = { error: true, };
        const { code, message, } = await fetch(
            API_BASE_URL + "/usuario-web/recover-password",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("recoverPasswordUsuarioPlataforma err");
        console.log(err);
        return { error: true, message: err, };
    }
}

export async function cambiarPassword(obj) {
    try {
        let data = { error: true, };
        const { code, message, } = await fetch(
            API_BASE_URL + "/usuario-web/cambiar-password",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("cambiarPassword err");
        console.log(err);
        return { error: true, message: err, };
    }
}

export async function validarUsuario() {
    try {
        let data = { valido: false, };
        const { code, valido, message, } = await fetch(
            API_BASE_URL + "/usuario-web/validar-usuario",
            {
                headers: getHeaders(),
                method: POST,
                // body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('valido');
        // console.log(valido);
        if (code === SUCCESS) {
            data.valido = valido;
        }
        if (code === FAILURE) {
            data.valido = false;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("validarUsuario err");
        console.log(err);
        return { error: true, message: err, };
    }
}